import { render, staticRenderFns } from "./PhoneOrTgInputGroup.vue?vue&type=template&id=9bacce66&scoped=true"
import script from "./PhoneOrTgInputGroup.vue?vue&type=script&lang=ts"
export * from "./PhoneOrTgInputGroup.vue?vue&type=script&lang=ts"
import style0 from "./PhoneOrTgInputGroup.vue?vue&type=style&index=0&id=9bacce66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bacce66",
  null
  
)

export default component.exports